// extracted by mini-css-extract-plugin
export default {"host_page":"hostpage_host_page__Jn+uX"};